import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchServiceDatabases } from '@/features/asset-detail/api/databasesApi';
import type { DatabasesResponse, FetchDatabasesOptions } from '@/features/asset-detail/api/databasesApi';

export const useServiceDatabases = (
  serviceName: string,
  options: FetchDatabasesOptions = {},
  enabled: boolean = true
) => {
  return useQuery<DatabasesResponse | null>({
    queryKey: assetKeys.serviceDatabases(serviceName, options.includeDeleted ?? false),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchServiceDatabases(serviceName, options);
    },
    enabled: enabled && !!serviceName,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
